"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseKey"));

var _react = _interopRequireDefault(require("react"));

var _reactErrorBoundary = require("react-error-boundary");

var _Routes = _interopRequireDefault(require("./Routes"));

var _application = require("../context/application");

var _FallbackError = _interopRequireDefault(require("../components/FallbackError"));

var _Application = _interopRequireDefault(require("../abstracts/Application"));

var currentConfig = {
  routes: [],
  navigate: [],
  wrappers: null,
  exclude: {
    routes: []
  }
};

var _routes = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_routes");

var Application = /*#__PURE__*/function (_AbstractApplication) {
  (0, _inherits2["default"])(Application, _AbstractApplication);

  var _super = (0, _createSuper2["default"])(Application);

  function Application(config) {
    var _this;

    (0, _classCallCheck2["default"])(this, Application);
    _this = _super.call(this);
    Object.defineProperty((0, _assertThisInitialized2["default"])(_this), _routes, {
      writable: true,
      value: null
    });
    _this.config = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, currentConfig), config);
    (0, _classPrivateFieldLooseBase2["default"])((0, _assertThisInitialized2["default"])(_this), _routes)[_routes] = new _Routes["default"](_this.config);
    return _this;
  }

  (0, _createClass2["default"])(Application, [{
    key: "routes",
    get: function get() {
      return (0, _classPrivateFieldLooseBase2["default"])(this, _routes)[_routes];
    }
  }, {
    key: "render",
    value: function render(cb) {
      var Routes = this.routes.render();
      return function () {
        return /*#__PURE__*/_react["default"].createElement(_reactErrorBoundary.ErrorBoundary, {
          fallbackRender: function fallbackRender(_ref) {
            var error = _ref.error;
            return /*#__PURE__*/_react["default"].createElement(_FallbackError["default"], {
              error: error
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_application.Provider, {
          value: {
            config: this.config,
            events: this.events,
            navigate: this.config['navigate']
          }
        }, /*#__PURE__*/_react["default"].createElement(Routes, null)));
      }.bind(this);
    }
  }]);
  return Application;
}(_Application["default"]);

var _default = Application;
exports["default"] = _default;